import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import { directives } from "./directive/directives";
import { CkeditorPlugin } from "@ckeditor/ckeditor5-vue";

import "normalize.css";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import "ckeditor5/ckeditor5.css";
import "./style.scss";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { useCommonStore } from "./store/common";

const pinia = createPinia();
const app = createApp(App);
app.use(router);
app.use(pinia);
app.use(i18n);
app.use(CkeditorPlugin);
// 全局注册
directives(app); // 指令
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component);
}

// Apply persisted dark-mode + font-theme preferences before first render
const commonStore = useCommonStore();
commonStore.applyDarkMode();
commonStore.applyFontTheme();

app.mount("#app");
